import { Stack, TerraformWorkflowTool as WorkflowTool } from "types/generated";
import { TERRAFORM_CUSTOM_VENDOR, VENDOR_CONFIG_TYPENAME } from "constants/vendor";
import {
  Gear,
  LogoAnsible,
  LogoCloudformation,
  LogoKubernetes,
  LogoOpentofu,
  LogoPulumi,
  LogoTerraform,
  LogoTerragrunt,
} from "components/icons/generated";
import { getStackVendorInfo } from "utils/vendor";
import Box from "ds/components/Box";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import StacksTableItemValue from "../../components/ItemValue";

type StacksTableVendorCellContentProps = {
  stack: Stack;
};

const StacksTableVendorCellContent = ({ stack }: StacksTableVendorCellContentProps) => {
  const { vendorConfig, effectiveTerraformVersion } = stack;

  // TF Stacks/Stack view
  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.TERRAFORM) {
    let label = effectiveTerraformVersion || vendorConfig.version || "";

    let icon = LogoTerraform;
    if (vendorConfig?.workflowTool === WorkflowTool.OpenTofu) {
      icon = LogoOpentofu;
    }

    if (vendorConfig?.workflowTool === WorkflowTool.Custom) {
      icon = Gear;
      label = TERRAFORM_CUSTOM_VENDOR;
    }

    return <StacksTableItemValue icon={icon}>{label}</StacksTableItemValue>;
  }

  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.TERRAGRUNT) {
    const vendorInfo = getStackVendorInfo(vendorConfig);

    if (!vendorInfo) return <StacksTableItemValue icon={LogoTerragrunt} />;

    return (
      <Box direction="column" gap="small">
        <StacksTableItemValue icon={vendorInfo.vendor.icon}>
          {vendorInfo.vendor.text}
        </StacksTableItemValue>

        {vendorInfo.vendorTool && (
          <StacksTableItemValue icon={vendorInfo.vendorTool.icon}>
            {vendorInfo.vendorTool.text}
          </StacksTableItemValue>
        )}
      </Box>
    );
  }

  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.PULUMI) {
    return <StacksTableItemValue tooltip="Pulumi" icon={LogoPulumi} />;
  }

  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.KUBERNETES) {
    return <StacksTableItemValue tooltip="Kubernetes" icon={LogoKubernetes} />;
  }

  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.CLOUD_FORMATION) {
    return <StacksTableItemValue tooltip="CloudFormation" icon={LogoCloudformation} />;
  }

  if (vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.ANSIBLE) {
    return <StacksTableItemValue tooltip="Ansible" icon={LogoAnsible} />;
  }

  return <TableCellEmpty />;
};

export default StacksTableVendorCellContent;
